import { SubjectManager } from "../../RxJS";

export const filterBarSubscriptionManager = new SubjectManager<string>();
